import React from 'react';
import { Star, Menu, Plus } from 'lucide-react';
export function Navigation() {
  return <header className="sticky top-0 z-50 w-full flex flex-col" data-id="element-249">
      {/* Top Ribbon */}
      <div className="w-full bg-orla-saffron h-8 flex items-center justify-center gap-2 px-4" data-id="element-250">
        <div className="flex gap-0.5" data-id="element-251">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-white text-white" data-id="element-252" />)}
        </div>
        <span className="text-white font-body font-semibold text-[13px]" data-id="element-253">
          40,000+ women in their prime
        </span>
      </div>

      {/* Main Nav */}
      <nav className="w-full h-[72px] bg-orla-bone border-b border-orla-border px-4 md:px-8 lg:px-12 flex items-center justify-between" data-id="element-254">
        {/* Left: Logo */}
        <a href="/" className="font-display font-black text-[28px] text-orla-sienna tracking-[-0.02em] lowercase" data-id="element-255">
          orla
        </a>

        {/* Center: Desktop Links */}
        <div className="hidden md:flex items-center gap-8" data-id="element-256">
          {['Treatments', 'Symptoms', 'Learn', 'About', 'Community'].map(item => <button key={item} className="flex items-center gap-1 text-orla-ink font-body font-medium text-[15px] hover:text-orla-sienna transition-colors" data-id="element-257">
                {item}
                <Plus className="w-3 h-3 text-orla-sienna" strokeWidth={3} data-id="element-258" />
              </button>)}
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-4 md:gap-6" data-id="element-259">
          <a href="/reviews" className="hidden md:block text-orla-ink font-body font-medium text-[15px] hover:text-orla-sienna transition-colors" data-id="element-260">
            Reviews
          </a>
          <a href="/login" className="hidden md:block text-orla-muted font-body text-[14px] hover:text-orla-ink transition-colors" data-id="element-261">
            Login
          </a>
          <button className="bg-orla-sienna text-orla-bone font-body font-semibold text-[14px] rounded-full px-6 py-3 hover:bg-orla-sienna/90 transition-colors" data-id="element-262">
            See My Options
          </button>
          <button className="md:hidden text-orla-ink p-1" data-id="element-263">
            <Menu className="w-6 h-6" data-id="element-264" />
          </button>
        </div>
      </nav>
    </header>;
}